import React, { Fragment, useState, useEffect } from "react";
import styled from "styled-components";
import { CheckBoxInput } from "../../../components/common/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "antd";
import Container from "../../../components/Layout/Container";
import AvailableMenu from "./components/AvailableMenu";
import { ButtonSecondary } from "../../../components/globals";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
} from "react-query";
import Axios from "axios";
import Spinner from "../../../components/common/Spinner";
import { antdMessageError } from "../../../helpers/Utils";
import { setOrderShopsOptions } from "../../../redux/Actions/options_action";
import {
  IconChevronDown,
  IconChevronUp,
  IconEdit,
  IconTrash,
} from "../../../components/Layout/Icons";
import ModalUserRoleCreate from "./components/ModalUserRoleCreate";
import { colors } from "../../../utils/colors";
import AntdConfirm from "../../../helpers/AntdConfirm";

const queryProductsClient = new QueryClient();

const fetcher = async ({ queryKey }) => {
  const [key] = queryKey;
  const response = await Axios.get(`/api/v1/${key}`);
  return response.data;
};

function UserRolesPage({match}) {
  const {
    isLoading,
    error,
    data = [],
    refetch,
  } = useQuery({
    queryKey: ["user_roles"],
    queryFn: fetcher,
  });
  const { order_shops } = useSelector((state) => state.options);

  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [Open, setOpen] = useState([]);

  useEffect(() => {
    dispatch(setOrderShopsOptions("all"));
  }, []);

  const medis = AvailableMenu(
    { id: 1 },
    { tr_request: 5, force_payment_accepted_status: true }
  );

  const mutationPUT = useMutation({
    mutationFn: (value) =>
      Axios.put(`/api/v1/user_roles/${value.id}`, {
        user_roles: value,
      }).then((res) => res.data),
    onSuccess: () => {
      refetch();
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const mutationDelete = useMutation({
    mutationFn: (record_id) =>
      Axios({
        url: `/api/v1/user_roles/${record_id}`,
        method: "DELETE",
      }).then((res) => res.data),
    onSuccess: () => {
      refetch();
      // antdMessageSuccess();
      // setPreviewCart(null);
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  console.log("Roles");

  return (
    <Container
      location={{
        locationName: "Roles",
        locationUrl: match.url,
      }}
      breadcrumbs={[
        {
          label: "Options",
          value: "#",
        },
        {
          label: "Roles",
          value: match.url,
        },
      ]}
    >
      <QueryClientProvider client={queryProductsClient}>
        <div className="col-12">
          <div className="bg-white d-flex">
            <Table type="main">
              <TableLine className={"table-line text-sm"} padding_left={15}>
                <div>
                  <ButtonSecondary onClick={() => setModal(0)}>
                    Add new role
                  </ButtonSecondary>
                </div>
              </TableLine>
              <TableLine className={"table-line text-sm"} padding_left={15}>
                <div>Projects</div>
              </TableLine>

              {medis.map((d) => (
                <RenderTableLinePossibleOptions
                  key={d.uuid}
                  {...d}
                  setOpen={setOpen}
                  Open={Open}
                />
              ))}
            </Table>
            <TableSwitch>
              {isLoading ? (
                <Spinner />
              ) : error ? (
                <div>{JSON.stringify(error)}</div>
              ) : (
                data?.map((e, idx) => (
                  <Fragment key={e.id}>
                    <Table>
                      <TableLine
                        className={`table-line text-sm justify-content-center font-medium`}
                        style={{
                          gap: 5,
                        }}
                      >
                        {e.title}

                        <div
                          style={{
                            width: 30,
                            height: 30,
                          }}
                        >
                          <ButtonSecondary
                            bgActiveColor={"#fff"}
                            className="btn-sm p-1"
                            outline={true}
                            onClick={() => setModal(e.id)}
                          >
                            <IconEdit color={colors["primary"]} />
                          </ButtonSecondary>
                        </div>
                        <Tooltip
                          placement="top"
                          title={
                            e.used
                              ? "You can’t delete role, it has users assigned"
                              : "Erasing the role"
                          }
                        >
                          <div
                            typeof="button"
                            className={`btn btn-sm ${
                              e.used ? "btn-secondary" : "btn-danger"
                            } border-radius-3 cursor-pointer`}
                            style={{
                              width: 30,
                              height: 30,
                            }}
                            onClick={
                              e.used
                                ? () => {}
                                : () =>
                                    AntdConfirm({
                                      onOk: () => mutationDelete.mutate(e.id),
                                    })
                            }
                            disabled={mutationDelete.isLoading || e.used}
                          >
                            <IconTrash color="#fff" />
                          </div>
                        </Tooltip>
                      </TableLine>
                      <TableLine
                        className={`table-line text-sm justify-content-center`}
                        style={{
                          textAlign: "center",
                          lineHeight: "16px",
                        }}
                      >
                        {e.shop_ids
                          .map(
                            (value) =>
                              order_shops.find((d) => d.value == value)
                                ?.label || value
                          )
                          .join("; ")}
                      </TableLine>
                      {medis.map((d) => (
                        <RenderTableLinePermissions
                          key={d.uuid}
                          {...d}
                          parent_uuid={e.uuid}
                          Open={Open}
                          permissions={e.permissions}
                          its_even={idx & 1}
                          onUpdate={(uuid, extras) => {
                            let obj = e;
                            const first_uid = uuid[0];
                            const parent_uid = uuid[1];
                            const value = !obj.permissions[first_uid];
                            obj.permissions[first_uid] = value;
                            if (extras && extras.length > 0) {
                              extras.forEach(
                                (e) => (obj.permissions[e] = value)
                              );
                            }
                            if (parent_uid && value) {
                              obj.permissions[parent_uid] = true;
                            }
                            delete obj.used;
                            mutationPUT.mutate(obj);
                          }}
                        />
                      ))}
                    </Table>
                  </Fragment>
                ))
              )}
            </TableSwitch>
          </div>
        </div>
        {typeof modal == "number" && (
          <ModalUserRoleCreate
            user_role_id={modal}
            setModal={() => {
              setModal(false);
              refetch();
            }}
          />
        )}
      </QueryClientProvider>
    </Container>
  );
}

const RenderTableLinePermissions = ({
  title,
  uuid,
  parent_uuid,
  options,
  Open,
  children = false,
  permissions,
  onUpdate,
  its_even,
}) => {
  return (
    <Fragment>
      <TableLine
        className={
          children
            ? `table-line children ${
                its_even ? "its-event" : ""
              } justify-content-center`
            : `table-line ${its_even ? "its-event" : ""} justify-content-center`
        }
      >
        <CheckBoxInput
          checked={permissions[uuid] || false}
          onChange={() => {
            console.log({ uuid, parent_uuid, options });
            onUpdate(
              [uuid, parent_uuid],
              options?.filter((e) => !e?.options).map((e) => e.uuid)
            );
          }}
        />
      </TableLine>
      {Open.includes(title) &&
        options?.length > 0 &&
        options.map((e) => (
          <RenderTableLinePermissions
            key={e.uuid}
            {...e}
            parent_uuid={uuid}
            Open={Open}
            children={true}
            permissions={permissions}
            onUpdate={onUpdate}
            its_even={its_even}
          />
        ))}
    </Fragment>
  );
};

const RenderTableLinePossibleOptions = ({
  title,
  options,
  setOpen,
  Open,
  padding_left = 0,
  uuid,
}) => {
  const shrinkClick = () => {
    setOpen((prev) => {
      if (prev.includes(title)) {
        return prev.filter((e) => e !== title);
      } else {
        return [...prev, title];
      }
    });
  };
  const its_openned = Open.includes(title);
  return (
    <Fragment>
      <TableLine
        className={
          !uuid
            ? "table-line text-danger"
            : padding_left
            ? "table-line children"
            : "table-line"
        }
        padding_left={padding_left + 15}
      >
        {title}
        {options && options?.length > 0 && (
          <div className="ml-auto">
            {its_openned ? (
              <IconChevronUp
                className="cursor-pointer ml-2"
                onClick={() => shrinkClick()}
              />
            ) : (
              <IconChevronDown
                className="cursor-pointer ml-2"
                onClick={() => shrinkClick()}
              />
            )}
          </div>
        )}
      </TableLine>
      {its_openned &&
        options &&
        options.length > 0 &&
        options.map((e) => (
          <RenderTableLinePossibleOptions
            key={e.url || e.title}
            {...e}
            setOpen={setOpen}
            Open={Open}
            padding_left={padding_left + 5}
          />
        ))}
    </Fragment>
  );
};

const UserRolesPageWrapper = ({match}) => {
  return (
    <QueryClientProvider client={queryProductsClient}>
      <UserRolesPage match={match} />
    </QueryClientProvider>
  );
};

export default UserRolesPageWrapper;

const Table = styled.div`
  width: 200px;

  ${(props) =>
    props.type == "main" && "box-shadow: 5px 0px 21px rgba(0, 0, 0, 0.09);"}
  ${(props) => props.type == "main" && "z-index: 1;"}
  
  .table-line:nth-child(even) {
    background-color: #f8f8f8;
  }
  .table-line.children:nth-child(odd) {
    background-color: #f5fcff !important;
  }
  .table-line.children:nth-child(even) {
    background-color: #ebf9fe !important;
  }
  .table-line.its-event:nth-child(even) {
    background-color: #f6f6f6;
  }
  .table-line.children.its-event:nth-child(even) {
    background-color: #f5fcff !important;
  }
`;
const TableSwitch = styled.div`
  display: flex;
  overflow-x: scroll;
  width: 100%;
`;
const TableLine = styled.div`
  min-width: 191px;
  height: 52px;
  display: flex;
  align-items: center;
  padding: 15px 15px 15px
    ${(props) => (props.padding_left ? `${props.padding_left}px` : `0px`)};
`;
